export default {
  SET_LOAN_DETAILS: 'setLoanDetails',
  SET_BID_DATA: 'setBidData',
  START_TRANSACTION: 'startTransaction',
  COMPLETE_TRANSACTION: 'completeTransaction',
  HANDLE_COMMITMENT_RESULT: 'handleCommitmentResult',
  SET_LOADING: 'setLoading',
};
